var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2ZM12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM16.615 6H7.385C6.619 6 6 6.62 6 7.384V16.614C6 17.38 6.619 18 7.385 18H16.615C17.381 18 18 17.38 18 16.615V7.385C18 6.62 17.381 6 16.615 6ZM12 9.693C13.274 9.693 14.309 10.725 14.309 12C14.309 13.275 13.274 14.307 12 14.307C10.726 14.307 9.693 13.274 9.693 12C9.693 10.726 10.726 9.693 12 9.693ZM16.5 16.039C16.5 16.294 16.293 16.5 16.039 16.5H7.961C7.707 16.5 7.5 16.293 7.5 16.039V11H8.449C8.404 11.158 8.371 11.32 8.347 11.486C8.324 11.654 8.309 11.825 8.309 12C8.309 14.04 9.961 15.693 12 15.693C14.039 15.693 15.691 14.04 15.691 12C15.691 11.826 15.676 11.654 15.652 11.486C15.629 11.32 15.594 11.158 15.55 11H16.5V16.039ZM16.5 9.048C16.5 9.303 16.293 9.51 16.039 9.51H14.951C14.695 9.51 14.49 9.302 14.49 9.048V7.961C14.49 7.706 14.695 7.5 14.951 7.5H16.039C16.293 7.5 16.5 7.707 16.5 7.961V9.048Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.763fcdb73a2c531691e47bda0b78254f.svg";
export { ForwardRef as ReactComponent };